/**
 * Whether PostHog initializes at all, in the browser and on the server.
 *
 * A key is the only condition. Local initializes too, because feature flags come from PostHog.
 * Whether events leave the app is a separate question: see `shouldSendPostHogEvents`.
 */
export function isPostHogEnabled(): boolean {
  return !!process.env.NEXT_PUBLIC_POSTHOG_KEY;
}
